// extracted by mini-css-extract-plugin
module.exports =  {"duplicateRoadmapPortal":"HKjTikid","modalContent":"z9OirbRl","label":"bKC54cFF","smallLabel":"esepB3yc"};